'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _classConcat = require('../../utils/classConcat');

var _classConcat2 = _interopRequireDefault(_classConcat);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactChildrenUtilities = require('react-children-utilities');

var _reactChildrenUtilities2 = _interopRequireDefault(_reactChildrenUtilities);

var _CardAction = require('./CardAction');

var _CardAction2 = _interopRequireDefault(_CardAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = function Card(_ref) {
  var children = _ref.children,
      border = _ref.border,
      shadow = _ref.shadow,
      primary = _ref.primary,
      alt = _ref.alt,
      stretch = _ref.stretch,
      modifiers = _ref.modifiers,
      className = _ref.className,
      imgSrc = _ref.imgSrc,
      imgAlt = _ref.imgAlt,
      title = _ref.title,
      inline = _ref.inline,
      sInline = _ref.sInline,
      mInline = _ref.mInline,
      lInline = _ref.lInline;

  var baseClass = 'luna-class',
      articleClassNames = (0, _classnames2.default)([baseClass, [{
    'luna-card--border': border,
    'luna-card--shadow': shadow,
    'luna-card--primary': primary,
    'luna-card--alt': alt,
    'luna-card--stretch': stretch,
    'luna-card--inline': inline,
    'luna-card--inline@s': sInline,
    'luna-card--inline@m': mInline,
    'luna-card--inline@l': lInline
  }, (0, _classConcat2.default)(baseClass, modifiers), className]]);
  var cardActions = _reactChildrenUtilities2.default.filter(children, function (child) {
    return child.type === _CardAction2.default;
  });
  var content = _reactChildrenUtilities2.default.filter(children, function (child) {
    return child.type !== _CardAction2.default;
  });
  return _react2.default.createElement(
    'article',
    { className: articleClassNames },
    imgSrc && _react2.default.createElement(
      'figure',
      { className: 'luna-card__figure' },
      _react2.default.createElement('img', { className: 'luna-image', src: imgSrc, alt: imgAlt || '' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'luna-card__block' },
      title && _react2.default.createElement(
        'h1',
        { className: 'luna-card__title' },
        title
      ),
      content
    ),
    cardActions && cardActions.length > 0 && _react2.default.createElement(
      'div',
      { className: 'luna-card__actions' },
      cardActions
    )
  );
};

Card.propTypes = {
  modifiers: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
  border: _propTypes2.default.bool,
  shadow: _propTypes2.default.bool,
  primary: _propTypes2.default.bool,
  alt: _propTypes2.default.bool,
  stretch: _propTypes2.default.bool,
  inline: _propTypes2.default.bool,
  sInline: _propTypes2.default.bool,
  mInline: _propTypes2.default.bool,
  lInline: _propTypes2.default.bool,
  imgSrc: _propTypes2.default.string,
  imgAlt: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string])
};

exports.default = Card;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Card/Card.js